// Page Edit Wrapper
// Fetches page data and renders PageBuilder
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import pagesService from '../../services/pagesService';
import PageBuilder from './PageBuilder';

const PageEdit = () => {
  const { pageId } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPage();
  }, [pageId]);

  const fetchPage = async () => {
    try {
      setLoading(true);
      setError(null);
      const pageData = await pagesService.getPage(pageId);
      setPage(pageData);
    } catch (error) {
      console.error('Error fetching page:', error);
      setError('Failed to load page');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    navigate('/portal-settings');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#7A99D8]"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600 mb-4">{error}</p>
          <button
            onClick={handleClose}
            className="px-4 py-2 bg-[#7A99D8] text-white rounded-lg hover:bg-[#6A89C8]"
          >
            Back to Portal Settings
          </button>
        </div>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-400 mb-4">Page not found</p>
          <button
            onClick={handleClose}
            className="px-4 py-2 bg-[#7A99D8] text-white rounded-lg hover:bg-[#6A89C8]"
          >
            Back to Portal Settings
          </button>
        </div>
      </div>
    );
  }

  return <PageBuilder page={page} onClose={handleClose} />;
};

export default PageEdit;
